import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { isWikiAuthenticated } from '../../utils/wikiAuth';

const EXPIRY_CHECK_INTERVAL_MS = 60 * 1000; // раз в минуту

const ProtectedWikiRoute = ({ children }) => {
  const navigate = useNavigate();
  const authenticated = isWikiAuthenticated();

  // Периодическая проверка срока токена: при истечении редирект на логин (хук вызываем всегда, до любого return)
  useEffect(() => {
    if (!authenticated) return;
    const intervalId = setInterval(() => {
      if (!isWikiAuthenticated()) {
        navigate('/wiki/admin/login', { replace: true });
      }
    }, EXPIRY_CHECK_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [authenticated, navigate]);

  if (!authenticated) {
    return <Navigate to="/wiki/admin/login" replace />;
  }

  return children;
};

export default ProtectedWikiRoute;
